import { getApiActionTypes } from '../storeHelpers';

export const refreshFederalProFormaDataTypes = getApiActionTypes(
  'REFRESH_FEDERAL_PRO_FORMA_DATA_TYPES',
);
export const refreshGtwDataTypes = getApiActionTypes('REFRESH_GTW_DATA_TYPES');
